/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CodebookEntryResponse } from '../models/CodebookEntryResponse';
import type { CodebookExitResponse } from '../models/CodebookExitResponse';
import type { CreateCodebookEntryRequest } from '../models/CreateCodebookEntryRequest';
import type { CreateCodebookExitRequest } from '../models/CreateCodebookExitRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CodebookEntryApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create codebook
   * @param requestBody
   * @returns any Create codebook
   * @throws ApiError
   */
  public createCodebookEntry(
    requestBody?: CreateCodebookEntryRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/codebook-entry',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns any Get codebook
   * @throws ApiError
   */
  public getCodebookEntries(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<{
    items: Array<CodebookEntryResponse>;
    totalItems: number;
    totalPages: number;
    page: number;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-entry',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook
   * @param id
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns any Get codebook
   * @throws ApiError
   */
  public getCodebookEntriesByWarehouseId(
    id: string,
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<{
    items: Array<CodebookEntryResponse>;
    totalItems: number;
    totalPages: number;
    page: number;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-entries/{id}',
      path: {
        'id': id,
      },
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook by id
   * @param id
   * @returns CodebookEntryResponse Get codebook response
   * @throws ApiError
   */
  public getCodebookEntryById(
    id: string,
  ): CancelablePromise<CodebookEntryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-entry/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update
   * @param id
   * @param requestBody
   * @returns CodebookEntryResponse Update
   * @throws ApiError
   */
  public updateCodebookEntry(
    id: string,
    requestBody?: CreateCodebookEntryRequest,
  ): CancelablePromise<CodebookEntryResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/codebook-entry/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update
   * @param id
   * @param requestBody
   * @returns CodebookExitResponse Update
   * @throws ApiError
   */
  public updateCodebookExit(
    id: string,
    requestBody?: CreateCodebookExitRequest,
  ): CancelablePromise<CodebookExitResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/codebook-exit/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
